import styled from 'styled-components';

export const Relative = styled.div`
    position: relative;
    margin-top: 16px;
    flex-grow: 1;
`;

export const Animation = styled.div<{ animation?: string | undefined }>`
    position: absolute;
    overflow-y: auto;
    transition: all 1s;
    width: 100%;
    padding: 0 32px 96px 0;
    opacity: 0;
    visibility: ${(props) => (props.animation && props.animation === 'start' ? 'visible' : 'hidden')};
    ${(props) => props.animation && `animation: ${props.animation} 1s forwards`};
    top: 0;
    bottom: 0;

    @keyframes start {
        0% {
            opacity: 1;
            visibility: visible;
            transition: none;
        }
        100% {
            opacity: 1;
            visibility: visible;
        }
    }

    @keyframes intro-next {
        0% {
            top: 50px;
            transition: none;
            opacity: 0;
            visibility: visible;
        }
        0.1% {
            top: 50px;
            opacity: 0;
            visibility: visible;
        }
        100% {
            top: 0;
            opacity: 1;
            visibility: visible;
        }
    }

    @keyframes intro-previous {
        0% {
            top: -50px;
            transition: none;
            opacity: 0;
            visibility: visible;
        }
        0.1% {
            top: -50px;
            opacity: 0;
            visibility: visible;
        }
        100% {
            top: 0;
            opacity: 1;
            visibility: visible;
        }
    }

    @keyframes outro-next {
        0% {
            top: 0;
            opacity: 1;
            visibility: visible;
        }
        100% {
            top: -50px;
            opacity: 0;
            visibility: hidden;
        }
    }

    @keyframes outro-previous {
        0% {
            top: 0;
            opacity: 1;
            visibility: visible;
        }
        100% {
            top: 50px;
            opacity: 0;
            visibility: hidden;
        }
    }
`;
